export const SubscriptionsPage = {
  en: {
    Subscriptions: 'Subscriptions',
  },
  uk: {
    Subscriptions: 'Підписки',
  },
};

export const SubscriptionPage = {
  en: {
    'Start payment': 'Start payment',
    'To subscribe, make the start payment.':
      'To subscribe, make the start payment.',
    'Start payment confirmed.': 'Start payment confirmed.',
    'To subscribe, contact the administrator.':
      'To subscribe, contact the administrator.',
    'Subscription available until {{date}}. After this date, a new start payment will be required.':
      'Subscription available until {{date}}. After this date, a new start payment will be required.',
    'Buy subscription': 'Buy subscription',
  },
  uk: {
    'Start payment': 'Стартовий платіж',
    'To subscribe, make the start payment.':
      'Для оформлення підписки, зробіть стартовий платіж.',
    'Start payment confirmed.': 'Стартовий платіж підтверджено.',
    'To subscribe, contact the administrator.':
      'Для оформлення підписки зверніться до адміністратора.',
    'Subscription available until {{date}}. After this date, a new start payment will be required.':
      'Оформлення підписки доступно до {{date}} включно. Після цієї дати оформлення підписки буде вимагати повторної оплати стартового платежу.',
    'Buy subscription': 'Придбати підписку',
  },
};
